import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `TipoAlimentacion/deleteSeleccionTipoAlimentacion  `, method: 'POST', body: {list}, token: token})
}
